import { forwardRef } from 'react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './Button.css';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
type ButtonSize = 'sm' | 'md' | 'lg';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: ButtonVariant;
    size?: ButtonSize;
    icon?: ReactNode;
    iconPosition?: 'left' | 'right';
    fullWidth?: boolean;
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
    {
        variant = 'primary',
        size = 'md',
        icon,
        iconPosition = 'left',
        fullWidth = false,
        className = '',
        type = 'button',
        children,
        ...rest
    },
    ref,
) {
    const classes = [
        'ui-btn',
        `ui-btn--${variant}`,
        `ui-btn--${size}`,
        fullWidth ? 'ui-btn--full' : '',
        icon && !children ? 'ui-btn--icon-only' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <button ref={ref} type={type} className={classes} {...rest}>
            {icon && iconPosition === 'left' && <span className="ui-btn__icon">{icon}</span>}
            {children && <span className="ui-btn__label">{children}</span>}
            {icon && iconPosition === 'right' && <span className="ui-btn__icon">{icon}</span>}
        </button>
    );
});

export default Button;
